import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
    getInvestorDetailsByOrgId,
    sendOtp,
} from "../../../redux/slices/ProfileSlice";
import Loader from "../../../components/CustomLoader/Loader";
import {
    maskEmail,
    maskPhone,
    capitalizeWords,
} from "../../../helpers/helpers";
import CustomModal from "../../../components/CustomModal/CustomModal";
import OtpContent from "../../../components/OtpContent/OtpContent";
import NewEmailPhoneContent from "../../../components/NewEmailPhoneContent/NewEmailPhoneContent";
import ComAddressForm from "./ComAddressForm";
import EditDesignationForm from "./EditDropdownsForm";
import {
    GLOBAL_CONSTANTS,
    TITLE_TXT,
    USERTYPE_ID,
} from "../../../constants/constants";
import ProfileDetail from "../../../components/Details/ProfileDetail";

const { Title } = Typography;

const PersonalDetails = () => {
    const { user } = useSelector((state) => state.auth);
    const isHuf = user?.userTypeId === USERTYPE_ID.HUF;
    const isCompany = user?.userTypeId === USERTYPE_ID.ENTITY;
    const isNbfc = user?.userTypeId === USERTYPE_ID.NBFC
    const { investorData, loading } = useSelector((state) => state.profile);
    const dispatch = useDispatch();
    const [showEmail, setShowEmail] = useState(false);
    const [showPhone, setShowPhone] = useState(false);
    const [oldDetailOtpModalOpen, setOldDetailOtpModalOpen] = useState(false);
    const [newDetailModalOpen, setNewDetailModalOpen] = useState(false);
    const [newDetailOtpModalOpen, setNewDetailOtpModalOpen] = useState(false);
    const [isMobileOtp, setIsMobileOtp] = useState(false);
    const [newDetail, setNewDetail] = useState(null);
    const [comAddEditModalOpen, setComAddEditModalOpen] = useState(false);
    const [editDropdownsModalOpen, setEditDropdownsModalOpen] = useState(false);

    useEffect(() => {
        dispatch(getInvestorDetailsByOrgId(user?.orgId));
    }, [dispatch, user.orgId]);

    const handleDetailEdit = (detail) => {
        setOldDetailOtpModalOpen(true);

        const payload = {
            email: investorData?.email,
        };

        if (detail === "phone") {
            setIsMobileOtp(true);
            delete payload.email;
            payload.mobile = investorData?.contactPhoneNumber;
        }

        dispatch(sendOtp(payload));
    };

    const primaryAdd = (isCompany || isHuf || isNbfc)
        ? [
            investorData?.billingAddLine1,
            investorData?.billingAddLine2,
            investorData?.billingCityName,
            investorData?.billingDistrictName,
            investorData?.billingStateName,
            investorData?.billingCountryName,
            investorData?.billingZipCode,
        ]
        : [
            investorData?.primaryAddLine1,
            investorData?.primaryAddLine2,
            investorData?.primaryCityName,
            investorData?.primaryDistrictName,
            investorData?.primaryStateName,
            investorData?.primaryCountryName,
            investorData?.primaryZipCode,
        ];

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <div className="investor-details-container">
                    <div className="header-container">
                        <Title level={4}>{isHuf ? TITLE_TXT.KAR_DETS : TITLE_TXT.PER_DETS}</Title>
                    </div>
                    <div className="details-container">
                        <ProfileDetail
                            label={
                                isHuf
                                    ? GLOBAL_CONSTANTS.KAR_NAME
                                    : GLOBAL_CONSTANTS.NAME_AS_PER_PAN
                            }
                            value={investorData?.contactName}
                        />

                        <ProfileDetail
                            label={
                                isHuf ? GLOBAL_CONSTANTS.KAR_EMAIL : GLOBAL_CONSTANTS.EMAIL
                            }
                            value={
                                showEmail ? investorData?.email : maskEmail(investorData?.email)
                            }
                            isVerified={investorData?.isEmailVerified}
                            showValue={showEmail}
                            setShowValue={setShowEmail}
                            onEdit={() => handleDetailEdit("email")}
                            isMasked
                            isEditable
                        />

                        <ProfileDetail
                            label={
                                isHuf ? GLOBAL_CONSTANTS.KAR_PH_NUM : GLOBAL_CONSTANTS.PH_NUM
                            }
                            value={`+91 ${showPhone
                                ? investorData?.contactPhoneNumber
                                : maskPhone(investorData?.contactPhoneNumber)
                                }`}
                            isVerified={investorData?.isPhoneNumberVerified}
                            showValue={showPhone}
                            setShowValue={setShowPhone}
                            onEdit={() => handleDetailEdit("phone")}
                            isMasked
                            isEditable
                        />

                        {(isCompany || isHuf || isNbfc) && (
                            <ProfileDetail
                                label={GLOBAL_CONSTANTS.DESIG}
                                value={
                                    capitalizeWords(investorData?.designationName) ||
                                    GLOBAL_CONSTANTS.NA
                                }
                                onEdit={() => setEditDropdownsModalOpen(true)}
                                isEditable
                            />
                        )}

                        <ProfileDetail
                            label={GLOBAL_CONSTANTS.PRIM_ADD}
                            value={
                                primaryAdd.filter(Boolean).join(", ") || GLOBAL_CONSTANTS.NA
                            }
                        />

                        <ProfileDetail
                            label={GLOBAL_CONSTANTS.COMM_ADD}
                            value={
                                [
                                    investorData?.billingAddLine1,
                                    investorData?.billingAddLine2,
                                    investorData?.billingCityName,
                                    investorData?.billingDistrictName,
                                    investorData?.billingStateName,
                                    investorData?.billingCountryName,
                                    investorData?.billingZipCode,
                                ]
                                    .filter(Boolean)
                                    .join(", ") || GLOBAL_CONSTANTS.NA
                            }
                            onEdit={() => setComAddEditModalOpen(true)}
                            isEditable
                        />

                        {oldDetailOtpModalOpen && (
                            <CustomModal
                                open={oldDetailOtpModalOpen}
                                centered
                                maskClosable={false}
                                onCancel={() => {
                                    setOldDetailOtpModalOpen(false);
                                    setIsMobileOtp(false);
                                }}
                                content={
                                    <OtpContent
                                        oldDetailOtpModalOpen={oldDetailOtpModalOpen}
                                        onClose={() => setOldDetailOtpModalOpen(false)}
                                        setNewDetailModalOpen={setNewDetailModalOpen}
                                        isMobileOtp={isMobileOtp}
                                        oldDetail={
                                            isMobileOtp
                                                ? investorData?.contactPhoneNumber
                                                : investorData?.email
                                        }
                                    />
                                }
                            />
                        )}
                        {newDetailModalOpen && (
                            <CustomModal
                                open={newDetailModalOpen}
                                centered
                                maskClosable={false}
                                onCancel={() => {
                                    setNewDetailModalOpen(false);
                                    setIsMobileOtp(false);
                                }}
                                content={
                                    <NewEmailPhoneContent
                                        onClose={() => setNewDetailModalOpen(false)}
                                        setNewDetailOtpModalOpen={setNewDetailOtpModalOpen}
                                        setNewDetail={setNewDetail}
                                        isMobileOtp={isMobileOtp}
                                    />
                                }
                            />
                        )}
                        {newDetailOtpModalOpen && (
                            <CustomModal
                                open={newDetailOtpModalOpen}
                                centered
                                maskClosable={false}
                                onCancel={() => {
                                    setNewDetailOtpModalOpen(false);
                                    setIsMobileOtp(false);
                                }}
                                content={
                                    <OtpContent
                                        newDetail={newDetail}
                                        setNewDetail={setNewDetail}
                                        newDetailOtpModalOpen={newDetailOtpModalOpen}
                                        setNewDetailModalOpen={setNewDetailModalOpen}
                                        onClose={() => setNewDetailOtpModalOpen(false)}
                                        isMobileOtp={isMobileOtp}
                                    />
                                }
                            />
                        )}
                        {editDropdownsModalOpen && (
                            <CustomModal
                                open={editDropdownsModalOpen}
                                centered
                                maskClosable={false}
                                onCancel={() => setEditDropdownsModalOpen(false)}
                                content={
                                    <EditDesignationForm
                                        designation={investorData?.designationName}
                                        isDesignation={true}
                                        setEditDropdownsModalOpen={setEditDropdownsModalOpen}
                                    />
                                }
                            />
                        )}
                        {comAddEditModalOpen && (
                            <CustomModal
                                open={comAddEditModalOpen}
                                centered
                                maskClosable={false}
                                onCancel={() => setComAddEditModalOpen(false)}
                                content={
                                    <ComAddressForm
                                        investorData={investorData}
                                        setComAddEditModalOpen={setComAddEditModalOpen}
                                    />
                                }
                            />
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default PersonalDetails;
